var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2152_13051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2152_13051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99497 12.7498C9.89497 12.7498 9.80122 12.7325 9.71372 12.6978C9.62622 12.663 9.54775 12.6109 9.4783 12.5415L5.52701 8.59021C5.36954 8.43274 5.29428 8.25331 5.30122 8.05192C5.30817 7.85053 5.38803 7.67345 5.5408 7.52067C5.69358 7.36789 5.87067 7.2915 6.07205 7.2915C6.27344 7.2915 6.45053 7.36789 6.6033 7.52067L9.99914 10.9373L13.4158 7.52067C13.5686 7.36789 13.7457 7.29498 13.9471 7.30192C14.1484 7.30887 14.3255 7.38873 14.4783 7.5415C14.6311 7.69428 14.7075 7.87137 14.7075 8.07275C14.7075 8.27414 14.6287 8.45318 14.4713 8.60988L10.52 12.5415C10.445 12.6109 10.3637 12.663 10.2762 12.6978C10.1887 12.7325 10.095 12.7498 9.99497 12.7498Z",
    fill: "#2E3336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.f2ad2f543c74063e617c57cdc7ca839c.svg";
export { ForwardRef as ReactComponent };